import { initLayoutControl } from './layoutControl.js';
import { initAnimation } from './animation.js';
import { initInteraction } from './interaction.js';

const init = () => {
    initLayoutControl();
    initAnimation();
    initInteraction();

    document.body.classList.add('is-loaded');
};

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('astro:after-swap', init);
